import { CreateWithdrawResponse } from '@libs/api-reference';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

function withdrawFactory(formModel: CreateWithdrawModel) {
  return {
    destinationAccountId: formModel.selectedAccountId,
    requestDepositDate: formModel.selectedTimeSpan,
    withdrawalValue: formModel.requestWithdrawalValue,
    sourceAccountUsageType: 8 as const,
  };
}

type UseCreateWithdrawalOptions = {
  onReject?: UseMutationConfig<CreateWithdrawResponse>['onReject'];
  onSuccess?: UseMutationConfig<CreateWithdrawResponse>['onSuccess'];
};

export type CreateWithdrawModel = {
  selectedAccountId: number;
  requestWithdrawalValue: number;
  dueDate?: Date;
  selectedTimeSpan: Date;
  description?: string;
};

export default function useCreateWithdrawalQuery({
  onReject,
  onSuccess,
}: UseCreateWithdrawalOptions = {}) {
  const {
    execute: createWithdrawal,
    isPending: isCreatingWithdrawal,
    ...query
  } = useMutation<CreateWithdrawResponse>(
    ({ formModel }: { formModel: CreateWithdrawModel }) =>
      API.createWithdrawal(withdrawFactory(formModel)),
    {
      onReject,
      onSuccess,
    }
  );

  return { createWithdrawal, isCreatingWithdrawal, ...query };
}
